<div>
    <div class="div-franja">
        <img src="/estadisticas-economicas/assets/img/logolinea-brcblanco-footer.svg" class="img-logo-mona">
    </div>
</div>
<div id="encustaSatisfaccion" class="div-modal-dialog">

    <!--********************************************************* PARTE 1 TITULO **********************************************-->
    <div>
        <div class="div-boton-cerrar-dialog"><button mat-button mat-dialog-close (click)="closeDialog()">X</button>
        </div>
        <div>
            <h2 class="metadata-titulo">Conozca la nueva sección de estadísticas económicas</h2>
        </div>
    </div>

    <!--********************************************************* PARTE 3 CONTENIDO **********************************************-->
    <div id="tipoEncuestaNormal">
        <div class="div-contenedor-calificacion" *ngIf="!isAgradecimientos">
            <p>
                Lo(a) invitamos a consultar este video que podría ser de utilidad para quienes consultan estadísticas
                producidas y/o publicadas por el Banco de la República en esta sección.
            </p>
            <div class="div-razon-calificacion">
                <!--label>Por favor indíquenos sus comentarios:</label>
                <textarea name="razonCalificación" id="razonCalificacion" [(ngModel)]="razonOpinion"
                    class="textarea-razon-calificacion"></textarea-->
                <iframe width="560" height="315" src="https://www.youtube.com/embed/CYLFRBeXTI4?si=nbmQJ0h97B8DO5x9"
                    title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; 
                    gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin"
                    allowfullscreen>
                </iframe>
            </div>
            @if (!calificado) {
            <div>
                <p>
                    Califique qué tan útil fue este video:
                </p>
            </div>
            <div class="div-formulario-calificacion">
                <div class="boton-calificacion">
                    <img (click)="enviarCalificacion('MUY_UTIL')"
                        src="/estadisticas-economicas/assets/img/satisfaccion_muy_satisfecho.png"
                        class="img-calificacion" /><br><span>Muy útil</span>
                </div>

                <div class="boton-calificacion">
                    <img (click)="enviarCalificacion('UTIL')"
                        src="/estadisticas-economicas/assets/img/satisfaccion_satisfecho.png"
                        class="img-calificacion" /><br><span>Útil</span>
                </div>
                <div class="boton-calificacion">
                    <img (click)="enviarCalificacion('POCO_UTIL')"
                        src="/estadisticas-economicas/assets/img/satisfaccion_insatisfecho.png"
                        class="img-calificacion" /><br><span>Poco útil</span>
                </div>
            </div>
            }
            @else if (calificado) {
            <p class="texto-gracias">
                Gracias por calificarnos.
            </p>
            }

            <br><br>
            <div style="text-align: center;"><h5>Le invitamos a compartir su opinión</h5></div>
            <div><p>
                Si tiene inquietudes o dudas respecto a la sección de estadísticas del Banco, le invitamos a compartir
                sus inquietudes en
                un espacio reservado los martes y jueves 9-10 o 10-11 am COT. Si tiene interés en
                participar en ellos, le agradecemos diligenciar el siguiente formulario:
            </p></div>
            <div class="div-texto-info">
                <div class="div-campo-correo">
                    <label>Ingrese su nombre:</label>
                    <input #myInput type="text" id="myInputname" [(ngModel)]="nombre" required="true"
                        class="input-text-catalogo" placeholder="Nombre" title="Nombre">
                </div>
                <div class="div-campo-correo">
                    <label>Ingrese su correo electrónico:</label>
                    <input #myInput type="email" id="myInput" [(ngModel)]="correoElectronico" required="true"
                        class="input-text-catalogo" placeholder="Correo electrónico" title="Correo electrónico">
                    <small *ngIf="errores.correoObligatorio">El correo es obligatorio</small>
                </div>
                <div class="div-campo-correo flex-row">
                    <mat-form-field class="date-picker-2" appearance="outline">
                        <mat-label>Seleccione una fecha</mat-label>
                        <input matInput [matDatepicker]="picker" (click)="picker.open()" [(ngModel)]="fecha"
                            [min]="fechaMinima" [matDatepickerFilter]="onDisableDates" required="true">
                        <mat-hint style="font-size: small; color: #585858">DD/MM/AAAA</mat-hint>
                        <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                        <mat-datepicker #picker disabled="false"></mat-datepicker>
                    </mat-form-field>
                    <mat-form-field appearance="outline">
                        <mat-label>Seleccione hora</mat-label>
                        <mat-select [(ngModel)]="hora" required="true">
                            <mat-option value="9">9 am - 10 am</mat-option>
                            <mat-option value="10">10 am - 11 am</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>
            <p>
                Tenga en cuenta que si el cupo de asistencia ya fue completado, recibirá un correo en el que se
                le informará, para que en conjunto se reprograme la agenda. La solicitud debe hacerse mínimo la
                semana anterior a la fecha de la sesión.
            </p>
            <br>
            <fieldset toggleSpeed="500">
                <legend> Protección de Datos Personales </legend>
                <p class="texto-proteccion-datos-personales" [innerHTML]="parrafoTratamientoDatos">
                </p>
                <div class="div-check-acepto">
                    <label>Acepto:
                        <input type="checkbox" [(ngModel)]="proteccionDatosPersonales">
                    </label>
                </div>


            </fieldset>
            <br>
            <div class="div-texto-info">
                <div>
                    <p>Si tiene alguna sugerencia, petición de información adicional, queja, reclamo o felicitación
                        sobre el indicador o tema que está consultando,
                        le informamos que el Banco de la República cuenta con medios oficiales para su recepción, por lo
                        que solicitamos sean enviadas a través del
                        <a href="https://www.banrep.gov.co/atencion-ciudadano" target="_blank">Sistema de Atención a la
                            Ciudadanía</a> para poder darles la debida gestión.
                    </p>
                </div>
            </div>
            <div class="div-button">
                <div *ngIf="proteccionDatosPersonales && validarFormularioCompleto()" class="div-boton" (click)="enviarOpinion()">
                    <a>
                        <p>Enviar</p>
                    </a>
                </div>
            </div>
        </div>
    </div>

    <div class="div-agradecimientos" *ngIf="isAgradecimientos">
        <h2>Gracias por compartirnos su opinión!</h2>
    </div>
    <div class="div-button"><button mat-button mat-dialog-close (click)="closeDialog()">Cerrar</button></div>
</div>